import {useMutation, useQueryClient} from '@tanstack/react-query';
import {communicationApi} from '../api';
import {useNotifications} from '../../../shared';

export const useCommunicationMessageCreate = () => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();

  const createMessageMutation = useMutation({
    mutationFn: communicationApi.createMessage,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['communication-messages', 'infinite'], refetchType: 'all'});
      createNotification({
        title: 'Сообщение успешно создано',
        name: 'createCommunicationMessage',
        theme: 'success',
      });
    },
  });

  return {
    createMessageMutation,
  };
};
